<template>
  <div class="report">
    <div class="d d_list d_list2">
      <div :class="`d bar ${flag && 'bar_on'}`">
        <p class="a_back"><i class="iC i_back" @click="goBack"></i></p>
        <ul class="u u_sel">
          <li :class="{ on: formFlag }">
            <div class="d d_sel" @click="showForm">
              <div class="fl">{{ formTitle }}</div>
              <i class="iC i_jt2"></i>
            </div>
            <div class="d d_stip">
              <div class="d d_stip_i">
                <ul class="u_sel2">
                  <li
                    :class="{ hover: item.id == formId }"
                    v-for="item in formList"
                    :key="item.id"
                    @click="selectForm(item.id, item.name, item.type)"
                  >
                    <p class="oneLine">{{ item.name }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <school-info :list="list" v-if="type == 1" />
    <zF-info :list="list" v-if="type == 2" />
    <train :list="list" type="schoolCounselorTrainingData" v-if="type == 3" />
    <train :list="list" type="chiefCounselorTrainingData" v-if="type == 4" />
    <hLJ-medal :list="list" v-if="type == 5" />
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import ZFInfo from "@/components/statistics/ZFInfo";
import Train from "@/components/statistics/Train";
import HLJMedal from "@/components/statistics/HLJMedal";
import {
  sexArr,
  ageArr,
  eduArr,
  zzmmArr,
  jobArr,
  batchTeamList,
  yn,
  jobList,
  concurrentCoursesList,
  starts,
  schoolTypes,
  sgwlist,
  sgwJobList,
} from "@/common/js";
import { getReportform, getReportCounselor, getReportsgw,  } from "@/service/report";
import SchoolInfo from "@/components/statistics/SchoolInfo";

export default {
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const state = reactive({
      formTitle: "请指定查看填报表单项",
      province: "",
      provinceCode: "",
      city: "",
      cityCode: "",
      district: "",
      districtCode: "",
      flag: false,
      formFlag: false,
      formId: 0,
      type: 0,
      typeTitle: "请指定统计项目名称",
      typeList: [
        { name: "全国中小学大队辅导员信息收集", type: 1 },
        { name: "全国少工委主任信息收集", type: 2 },
      ],
      list: {},
      formList: [],
      tongjiNameList: [],
      tongjiDataList: [],
      ecShow: false,
      zongTotal: 0,

      formatAgeList: [],
      ageArrEl: ageArr,
      jobArrEl: jobArr,
    });

    const showType = () => {
      state.flag = !state.flag;
      state.formFlag = false;
      state.formTitle = "请指定统计项目名称";
      state.list = [];
    };
    onMounted(() => {
      getForm();
    });

    /** 获取统计表单的列表 */
    const getForm = async () => {
      const { data, code } = await getReportform();
      console.log("getForm data", data);
      if (code === 10000) {
        state.formList = data;
      }
    };
    /** 显示/隐藏 统计表单的列表 */
    const showForm = () => {
      state.formFlag = !state.formFlag;
    };
    /** 展示对应的表单统计 */
    const selectForm = (id, title, type) => {
      state.type = type;
      state.formId = id;
      state.formTitle = title;
      proxy.$showLoading();
      showForm();
      if (type == 1) {
        getCounselor();
      } else {
        getSGW(type);
      }
    };

    /**  大队辅导员的统计数据 */
    const getCounselor = async () => {
      const { formId, province, city, district } = state;
      const { code, data } = await getReportCounselor({
        formId,
        province,
        city,
        district,
        groupBy: "zzmm",
      });
      console.log("getCounselor data", data);
      if (code === 10000) {
        if (data) {
          if (data.result) {
            state.list = data.result;
          } else {
            state.list = [];
          }
        } else {
          state.list = [];
        }
      }
      proxy.$closeLoading();
    };
    /** 少工委统计数据 */
    const getSGW = async (type) => {
      const { formId } = state;
      const {
        code,
        data,
        data: { result },
      } = await getReportsgw({ formId, type });
      console.log("getSGW data", data);
      if (code == 10000 && result) {
        state.list = result;
      } else {
        state.result = [];
        state.ecShow = false;
      }
      proxy.$closeLoading();
    };
    const goBack = () => {
      router.go(-1);
    };

    return {
      ...toRefs(state),
      showType,
      goBack,
      showForm,
      selectForm,
      sexArr,
      eduArr,
      zzmmArr,
      jobArr,
      schoolTypes,
      batchTeamList,
      yn,
      jobList,
      concurrentCoursesList,
      starts,
      sgwlist,
      sgwJobList,
    };
  },
  components: {
    SchoolInfo,
    ZFInfo,
    Train,
    HLJMedal,
  },
};
</script>
<style lang="less" scoped>
.report {
  height: 100%;
  background: #fff;
  overflow-y: auto;
}
.fl {
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  font-size: 0.48rem;
}

.u9,
.u_cy {
  background-color: #f8fafc;
  display: flex;
}
.u9:nth-child(2n + 1),
.u_cy:nth-child(2n + 1) {
  background-color: #fff;
}

.u_title {
  background-color: #e5e7eb;
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 8px 8px 0 0;
}
.u4_tit li {
  border-right: 1px solid #dcdcdc;
  margin-right: -1px;
}
.u4 li {
  width: 50%;
}
.total_title {
  font-size: 0.42rem;
  padding: 0.233rem;
}
.line {
  border-bottom: 1px dashed #dcdcdc;
  margin: 0.5rem 0;
}
.cnt_list {
  border: 1px solid #e5e7eb;
}
</style>
